/* ═══════════════════════════════════════════════════════════════════════════
   webhq_dom_observer.js  —  single shared MutationObserver for the whole page

   product_card_contract.js, product_brand.js, stock_guard.js,
   product_consumer_discount.js, infinite_scroll.js, catalog_search_enter.js,
   listing_quantity.js, product_offers.js, badges.js and
   product_variant_swatches.js each ran their own document/listing-wide
   MutationObserver. That's 10 observers firing on every DOM change, two of
   them (listing_quantity.js, product_variant_swatches.js) undebounced and
   watching document.body — reacting to any mutation anywhere on the page,
   not just the product listing.

   This file owns the one observer and hands subscribers a deduplicated,
   rAF-batched list of added/removed roots instead: mutations are collected
   as they happen, and all handlers run once per animation frame with nested
   nodes collapsed into their outermost batched ancestor. Subscribers filter
   the roots down to whatever container they actually care about.

   API (available to any script loaded after this one):
     window.webhqDom.onAdded(fn)    fn(addedRoots: Element[])  once per flush
     window.webhqDom.onRemoved(fn)  fn(removedNodes: Element[])
     window.webhqDom.off(fn)        unsubscribe from every list
   ═══════════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  if (window.webhqDom) return;

  var addedHandlers   = [];
  var removedHandlers = [];

  var pendingAdded   = [];
  var pendingRemoved = [];
  var frame = null;

  function flush() {
    frame = null;

    /* Collapse nested inserts: a node whose ancestor is also in the batch
       will be swept when the ancestor is scanned — delivering both would
       make subscribers process the same subtree twice. */
    var roots = pendingAdded.filter(function (node, i) {
      return !pendingAdded.some(function (other, j) {
        return j !== i && other !== node && other.contains(node);
      });
    });
    var removed = pendingRemoved;
    pendingAdded = []; pendingRemoved = [];

    if (roots.length)   addedHandlers.slice().forEach(function (fn)   { try { fn(roots);   } catch (_) {} });
    if (removed.length) removedHandlers.slice().forEach(function (fn) { try { fn(removed); } catch (_) {} });
  }

  function schedule() {
    if (frame !== null) return;
    frame = window.requestAnimationFrame
      ? requestAnimationFrame(flush)
      : setTimeout(flush, 16);
  }

  function start() {
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        for (var a = 0; a < m.addedNodes.length; a++) {
          var added = m.addedNodes[a];
          if (added.nodeType === 1 && pendingAdded.indexOf(added) === -1) pendingAdded.push(added);
        }
        for (var r = 0; r < m.removedNodes.length; r++) {
          if (m.removedNodes[r].nodeType === 1) pendingRemoved.push(m.removedNodes[r]);
        }
      }
      if (pendingAdded.length || pendingRemoved.length) schedule();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  window.webhqDom = {
    onAdded:   function (fn) { addedHandlers.push(fn); },
    onRemoved: function (fn) { removedHandlers.push(fn); },
    off: function (fn) {
      [addedHandlers, removedHandlers].forEach(function (list) {
        var i = list.indexOf(fn);
        if (i !== -1) list.splice(i, 1);
      });
    },
  };

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }

}());
